import { Spine } from "pixi-spine";
import * as PIXI from "pixi.js";

import loader from "./follower-loader.js";
import { getRgbPercentagesArrayFromString } from "./get-rgb-percentages-array-from-string.js";

const SLOTS_FOR_COLOR_APPLICATION = [
  "HEAD_SKIN_BTM",
  "HEAD_SKIN_TOP",
  "ARM_LEFT_SKIN",
  "ARM_RIGHT_SKIN",
  "LEG_LEFT_SKIN",
  "LEG_RIGHT_SKIN",
  "MARKINGS",
];

const offScreenCanvasB = document.createElement("canvas");
offScreenCanvasB.id = "follower-variations-renderer";
const width = 250;
const height = 255;

const app = new PIXI.Application({
  view: offScreenCanvasB,
  width: width,
  height: height,
  //backgroundAlpha: 0,
  backgroundColor: 0x00ff00,
});

window.app = app;

const container = new PIXI.Container();
const renderer = PIXI.autoDetectRenderer();

export function getVariationImagesMap(variations) {
  const images = {};

  const existingCanvas = document.body.querySelector(`#${offScreenCanvasB.id}`);
  if (existingCanvas) {
    document.body.removeChild(existingCanvas);
  }
  document.body.appendChild(app.view);

  const follower = new Spine(loader.resources.follower.spineData);
  follower.x = app.screen.width / 2 + 10;
  follower.y = app.screen.height - 5;

  follower.state.setAnimation(0, "Avatars/avatar-normal", true);

  app.stage.addChild(follower);

  const allSkinNamesInSpineData = follower.spineData.skins.map(
    (skin) => skin.name
  );
  const getAllOtherForSkinName = (skinName) => {
    return allSkinNamesInSpineData.filter(
      (skin) => skin !== skinName && skin.startsWith(skinName)
    );
  };

  const fullVariationMap = Object.entries(variations).reduce(
    (map, [skinName, colorOptions]) => {
      const allOtherVariationsForSkinName = getAllOtherForSkinName(skinName);
      allOtherVariationsForSkinName.forEach((variationSkinName) => {
        map[variationSkinName] = colorOptions;
      });
      return map;
    },
    variations
  );

  return Object.entries(fullVariationMap).reduce(
    (map, [skinName, colorOptions]) => {
      colorOptions.forEach((colorOption) => {
        follower.skeleton.setSkin(follower.skeleton.data.findSkin(skinName));

        SLOTS_FOR_COLOR_APPLICATION.forEach((slotName) => {
          const [r, g, b] = getRgbPercentagesArrayFromString(
            colorOption[slotName]
          );
          const slot = follower.skeleton.findSlot(slotName);

          if (slot) {
            Object.assign(slot.color, {
              r,
              g,
              b,
            });
          }
        });

        map[`${skinName}-${colorOption.colorOptionIndex}`] =
          app.renderer.plugins.extract.base64(follower);
      });

      return map;
    },
    {}
  );
}
